import { createContext } from 'react';

export const DisplayHeightContext = createContext<number | undefined>(
  undefined,
);
